<template>
  <header class="header">
    <BaseContainer class="header__container">
      <div class="header__wrapper">
        <div id="mobile-menu">
          <NestedMenu
            class="header__mobile-menu"
            url="https://morrisons-corporate.uat.np.morconnect.com/navigation.json"
          ></NestedMenu>
        </div>
        <router-link to="/" class="block" title="Morrisons Corporate" role="navigation">
          <MorrisonsFarmingLogo v-if="farming" class="header__logo"></MorrisonsFarmingLogo>
          <MorrisonsLogo v-else class="header__logo"></MorrisonsLogo>
        </router-link>
        <div class="header__button-wrapper">
          <div class="header__buttons">
            <BaseButton variant="secondary" width="small" href="/about-us" bold>About us</BaseButton>
            <div class="header__perspective">
              <SubMenu class="header__SubMenu"></SubMenu>
            </div>
          </div>
          <div class="header__buttons">
            <BaseButton variant="secondary" width="small" href="/investors" bold>Investors</BaseButton>
            <div class="header__perspective">
              <SubMenu class="header__SubMenu"></SubMenu>
            </div>
          </div>
          <div class="header__buttons">
            <BaseButton
              variant="secondary"
              width="small"
              href="/corporate-responsibility"
              bold
            >Corporate Responsability</BaseButton>
            <div class="header__perspective">
              <SubMenu class="header__SubMenu"></SubMenu>
            </div>
          </div>
          <div class="header__buttons">
            <BaseButton variant="secondary" width="small" href="/media-centre" bold>Media Centre</BaseButton>
            <div class="header__perspective">
              <SubMenu class="header__SubMenu"></SubMenu>
            </div>
          </div>
          <div class="header__buttons">
            <BaseButton variant="secondary" width="small" bold>Suppliers</BaseButton>
            <div class="header__perspective">
              <SubMenu class="header__SubMenu"></SubMenu>
            </div>
          </div>
          <BaseButton class="header__search-button" variant="secondary" width="icon" bold>
            <BaseIcon name="search" size="28"></BaseIcon>
          </BaseButton>
        </div>
      </div>
    </BaseContainer>
  </header>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseContainer from '../elements/BaseContainer.vue'
import SubMenu from './SubMenu.vue'
import BaseButton from '../elements/BaseButton.vue'
import MorrisonsLogo from '@/assets/svg/morrisons-logo.svg?inline'
import MorrisonsFarmingLogo from '@/assets/svg/morrisons-farming-logo.svg?inline'

export default {
  name: 'TheHeader',
  components: {
    MorrisonsLogo,
    MorrisonsFarmingLogo,
    BaseButton,
    SubMenu,
    BaseContainer,
    BaseIcon
  },
  data() {
    return {
      isActive: false
    }
  },
  props: {
    farming: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>

<style lang="postcss">
.header {
  @apply bg-white top-0 z-100;
  position: sticky;
}
.header__container {
  @apply relative shadow-md bg-white z-100;
}
.header__wrapper {
  @apply flex justify-between items-center;
}
.header__button-wrapper {
  @apply min-w-10;
}
@screen lg {
  .header__wrapper {
    @apply py-2;
  }
}
.header__logo {
  @apply my-2;
  width: 94px;
  height: 46px;
}
@screen lg {
  .header__logo {
    width: 131px;
    height: 60px;
  }
}
.header__button-wrapper {
  @apply flex;
}
.header__buttons {
  @apply mr-2 hidden;
}
.header__buttons:last-of-type {
  @apply mr-0;
}
.header__search-button {
  @apply flex justify-center items-center ml-2;
}
.header__mobile-menu {
  @apply flex;
}
.header__SubMenu {
  @apply absolute pt-2 bg-white opacity-0 pointer-events-none transition-fast;
  top: 100%;
  transform-origin: 50% 0;
}
.header__perspective {
  @apply pointer-events-none;
}
@screen lg {
  .header {
    @apply shadow-md;
  }
  .header__container {
    @apply shadow-none;
  }
  .header__buttons {
    @apply flex flex-col relative;
  }
  .header__buttons:hover .header__SubMenu {
    @apply flex opacity-100 pointer-events-auto;
    transform: none;
  }
  .header__buttons:nth-child(3) .header__SubMenu,
  .header__buttons:nth-child(4) .header__SubMenu,
  .header__buttons:nth-child(5) .header__SubMenu,
  .header__buttons:nth-child(6) .header__SubMenu,
  .header__buttons:nth-child(7) .header__SubMenu {
    @apply right-0;
  }
  .header__search-button {
    @apply flex justify-center items-center;
  }
  .header__mobile-menu {
    @apply hidden;
  }
  #mobile-menu {
    @apply hidden;
  }
}
</style>